module.exports = __webpack_public_path__ + "media/images/city/083-belem-tower-5901a965e2678bf1ceed6c984947359d.svg";